import React, { useState } from "react";
import { setBudgetYearFilter } from "../../../../actions/actions/eventStats";
import { connect } from "react-redux";
import { budgetYearFilterStyle, getBudgetManagementYears } from "../../../../services/utils";
import ReactSelect, { components } from "react-select";
import { fetchBudgetData, generateFollowUp, updateFollowUp } from "../../../../actions/thunks/eventStats";
import FilterModal from "../../../common/BudgetManagement/FilterModal";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'pr-2 pl-2'} />
    </components.DropdownIndicator>
  );
};

const YearFilter = ({
  budgetManagement,
  followUp,
  originalFollowUp,
  budgetPerMonth,
  originalBudgetPerMonth,
  setBudgetYearFilter,
  generateFollowUp,
  updateFollowUp
}) => {

  const [visible, setVisible] = useState(false);
  const [nextYear, setNextYear] = useState('');

  const handleDontSaveClick = () => {
    setBudgetYearFilter(nextYear);
    setVisible(false);
  };

  const handleSaveClick = () => {
    const { followUp: bmFollowUp } = budgetManagement;

    if (bmFollowUp.length === 0) {
      const { appType, year, budgetPerMonth, globalBudget: { totalHTVA, registrantsCount, pricePerUnit } } = budgetManagement;
      generateFollowUp(appType, year, budgetPerMonth, totalHTVA, registrantsCount, pricePerUnit).then(() => {
        setBudgetYearFilter(nextYear);
        setVisible(false);
      });
    } else {
      const { annualTargetId, followUp: bmFollowUp } = budgetManagement;
      updateFollowUp(annualTargetId, bmFollowUp).then(() => {
        setBudgetYearFilter(nextYear);
        setVisible(false);
      });
    }
  };

  const handleCancelClick = () => {
    setVisible(false);
  };

  const handleSelectChange = (value) => {
    const followUpIsUnchanged = followUp.every((element, index) =>
      element.registrantsCount === originalFollowUp[index].registrantsCount &&
      element.followUpPricePerUnit === originalFollowUp[index].followUpPricePerUnit
    );
    const budgetPerMonthIsUnchanged = budgetPerMonth.every((element, index) =>
      element.registrantsCount === originalBudgetPerMonth[index].registrantsCount
    );

    if (followUpIsUnchanged && budgetPerMonthIsUnchanged) {
      setBudgetYearFilter(value.value);
    } else {
      setVisible(true);
      setNextYear(value.value);
    }
  };

  return (
    <div>
      <ReactSelect
        className="create-BM-date-filter"
        onChange={handleSelectChange}
        styles={budgetYearFilterStyle()}
        value={{ value: budgetManagement.year, label: budgetManagement.year }}
        placeholder={budgetManagement.year}
        components={{
          DropdownIndicator,
          IndicatorSeparator: () => null,
          Input: () => null
        }}
        options={getBudgetManagementYears().filter(year => year !== budgetManagement.year[0]).map((year) => ({
          value: year,
          label: year
        }))}
      />
      <FilterModal
        visible={visible}
        budgetManagement={budgetManagement}
        handleDontSaveClick={handleDontSaveClick}
        handleSaveClick={handleSaveClick}
        handleCancelClick={handleCancelClick}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
  followUp: state.budgetManagement.followUp,
  originalFollowUp: state.budgetManagement.originalFollowUp,
  budgetPerMonth: state.budgetManagement.budgetPerMonth,
  originalBudgetPerMonth: state.budgetManagement.originalBudgetPerMonth,
});

const mapDispatchToProps = {
  setBudgetYearFilter,
  generateFollowUp,
  updateFollowUp,
  fetchBudgetData
};

export default connect(mapStateToProps, mapDispatchToProps)(YearFilter);


// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/BudgetManagement/YearFilter.js